import React, { useState } from 'react';
import { requestPasswordReset } from '../services/api';

function RequestPasswordResetForm() {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setMessage('');

    if (!email) {
      setError('Please enter your email address');
      return;
    }

    // Basic email validation
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailPattern.test(email)) {
      setError('Please enter a valid email address');
      return;
    }

    setIsLoading(true);

    try {
      const result = await requestPasswordReset(email);
      setIsLoading(false);

      if (result.error) {
        setError(result.error);
      } else {
        setMessage(result.message);
        setEmail(''); // Clear form on success
      }
    } catch (err) {
      setIsLoading(false);
      setError('An unexpected error occurred. Please try again.');
    }
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-background">
      <form
        onSubmit={handleSubmit}
        className="w-full max-w-sm bg-surface rounded-lg shadow-lg p-6 space-y-5 border border-muted"
      >
        <h2 className="text-2xl font-bold text-brand-white text-center">
          Reset Password
        </h2>

        <p className="text-brand-gray-blue text-sm text-center">
          Enter your email address and we'll send you a link to reset your password.
        </p>

        {error && (
          <div className="bg-red-900/20 border border-red-500/50 text-red-300 px-4 py-3 rounded text-sm">
            {error}
          </div>
        )}

        {message && (
          <div className="bg-green-900/20 border border-green-500/50 text-green-300 px-4 py-3 rounded text-sm">
            {message}
          </div>
        )}

        <input
          type="email"
          placeholder="Email address"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="w-full p-3 bg-gray-800 border border-brand-gray-blue rounded focus:outline-none focus:ring-2 focus:ring-brand-blue focus:border-brand-blue text-brand-white placeholder-gray-400"
          disabled={isLoading}
          required
        />

        <button
          type="submit"
          className="w-full bg-brand-blue text-white font-semibold py-3 rounded-lg hover:bg-[#1a7aef] transition-colors disabled:bg-brand-blue/50 disabled:cursor-not-allowed"
          disabled={isLoading}
        >
          {isLoading ? 'Sending...' : 'Send Reset Link'}
        </button>

        <div className="border-t border-muted pt-4 mt-4">
          <a
            href="/login"
            className="block w-full text-center text-brand-blue hover:text-[#1a7aef] transition-colors text-sm"
          >
            Back to Login
          </a>
        </div>
      </form>
    </div>
  );
}

export default RequestPasswordResetForm;
